import { render, staticRenderFns } from "./driver-card-data-analysis.vue?vue&type=template&id=627bcea0&scoped=true"
import script from "./driver-card-data-analysis.vue?vue&type=script&lang=js"
export * from "./driver-card-data-analysis.vue?vue&type=script&lang=js"
import style0 from "./driver-card-data-analysis.vue?vue&type=style&index=0&id=627bcea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627bcea0",
  null
  
)

export default component.exports